export default {
  summary: {
    delivery: 'Consegna: Gift card in PDF via email',
  },
};
